<template>
    <div class="supporting-roll_list">
        <div class="title1" v-for="(item, index) in paperData" :key="index">
            <div class="paperName_name" :title="item.paperName" style="width: 46%" @click="analyse(item)">
                <div class="title-paper">{{ item.paperName }}</div>
          <div class="time-box">{{ item.testDate }}</div>
            </div>
            <div style="width: calc(54% - 240px)">
                <div class="usetime">
                    用时：{{ getTime(item.useTime) }}
                </div>
            </div>
            <div class="answer-btn">
                答对 <span class="correct">{{ item.answerYesCount }}</span>答错<span>{{ item.answerWrongCount }}</span>
                未判错<span class="notJudged">{{ item.answerNotJudgedCount }}</span>
            </div>
        </div>
        <div class="pagination-box" v-if="total > 0">
            <el-pagination class="ou-pagination" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="queryParams.pageNum"
                :page-sizes="[10, 20, 30, 40, 50]" :page-size="queryParams.pageSize"
                layout="total, prev, pager, next, sizes, jumper, slot" :total="total">
                <el-button class="ou-page-go">GO</el-button>
            </el-pagination>
        </div>
        <el-empty v-show="total === 0" description=""></el-empty>
    </div>
</template>
<script>
import { getAnswerPaperRecord } from "@/api/answer/answer";
import { paperGetToken } from "@/api/index/index";
import { testURL } from "@/utils/config.js";
export default {

    name: 'answeringHistory',
    props: {
        paperId: {
            type: String,
            default: "",
        },
        isEquip: {
            type: String,
            default: "",
        },
        goodsId: {
            type: String,
            default: "",
        },
        paperType: {
            type: String,
            default: "",
        },
        isZiCe: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            paperData: [],
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                answerPlatform: "",
                token: "",
                isEquip: "",
                userId:"",
                paperId: "",
                params1: "",
                params2: "",
            },
            total: 0,
        }
    },
    watch: {
        paperId() {
            this.getAnswerPaperRecord();
        }
    },
    mounted() {
        setTimeout(() => {
            this.getAnswerPaperRecord();
        }, 100);
    },
    methods: {

        //获取统计的答卷信息
        getAnswerPaperRecord() {
            if (!this.isEquip && !this.paperType && !this.paperId && !this.isZiCe) {
                return
            }
            paperGetToken().then((res) => {
                this.queryParams.token = res.data;
                this.queryParams.params1 = this.goodsId;
                this.queryParams.isEquip = this.isEquip || "";
                this.queryParams.paperId = this.paperId || "";
                this.queryParams.params2 = this.paperType || "";
                this.queryParams.userId = this.$store.getters.userId || "";
                getAnswerPaperRecord(this.queryParams).then((res) => {
                    if (res.code == 200) {
                        this.paperData = res.rows;
                        this.total = res.total;
                        this.$emit("upTotal",this.total)
                    }
                });
            });
        },

        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getAnswerPaperRecord();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getAnswerPaperRecord();
        },

        analyse(item) {
            if (this.isZiCe) {
                this.$router.push({
                    path: "/bookstore/answerRecord",
                    query: {
                        paperId: item.paperId,
                        ansRecordId: item.id,
                        goodsId: this.goodsId,
                        bookName: this.$route.query.bookName||"",
                    },
                });
            } else {
                window.open(testURL+`/answer-record?paperId=${item.paperId}&ansRecordId=${item.id}`)
                // this.$router.push({
                //     path: "/bookstore/analyse",
                //     query: {
                //         goodsId: this.$route.query.goodsId,
                //         testPaperId: item.id,
                //         paperId: item.paperId,
                //         fromType: "/user/myResources",
                //     },
                // });
            }

        },
        answer(item) {
            this.$router.push({
                path: "/bookstore/examination",
                query: {
                    testPaperId: item.filesId,
                    userId: this.$store.state.user.userId,
                    userName: this.$store.state.user.name,
                    goodsId: this.$route.query.goodsId,
                    fromType: "/user/myResources",
                    // bookName: this.bookName,
                    // showAi:
                    //   JSON.stringify(this.robotBook).indexOf(
                    //     this.$route.query.goodsId
                    //   ) !== -1
                    //     ? true
                    //     : false,
                },
            });
        },
        // 格式化时间
        getTime(time) {
            if (time) {
                let m = parseInt(time / 60);
                let s = time % 60;
                let date = (m > 9 ? m : "0" + m) + "分" + (s > 9 ? s : "0" + s) + "秒";
                return date;
            } else {
                return "";
            }
        },
    },
}
</script>


<style scoped lang="scss">
.supporting-roll_list {
    width: 100%;
    // margin: 16px auto 40px auto;
    background: #fffefd;

    .title {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 14px 80px;
        font-weight: 600;
        font-size: 18px;
        color: #333333;
    }

    .title1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-family: PingFang SC;
        padding: 20px 80px;
        color: #666666;
        border-bottom: 1px solid #F2F2F2;

        .paperName_name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
            color: #409EFF;
            display: flex;
            flex-direction: column;
            .title-paper{
                font-weight: 600;
                color: #333333;
                &:hover {
            text-decoration: underline 2px #409EFF;
        }
            }
            .time-box{
                padding-top: 6px;
                font-size: 14px;
                color: #999999;
            }
        }

        

    }

    .answer-btn {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;

        // cursor: pointer;
        .correct {
            color: #6FC54D;
        }

        .notJudged {
            color: #389FDD;
        }

        span {
            display: inline-block;
            min-width: 36px;
            padding: 0 4px;
        }
    }

}

.pagination-box {
    text-align: right;
    background: #fffefd;
    padding: 25px 10px;
}
</style>


<style lang="scss"></style>